export enum PhytoViewType {
    Unknown = 0,
    County,
    JLS,
    EconomicUnits,
    HarmfulOrganismsSubCategories,
    HarmfulOrganismsCultures,
    PhasesOfPlantGrowthAndDevelopmentSubCategories,
    PhasesOfPlantGrowthAndDevelopmentCultures,
    PhasesOfPlantGrowthAndDevelopmentSorts,
    HarmfulOrganismsSpecies,
    HarmfulOrganismsType,
    CultivationArea,
    HarmfulOrganismsAttributesOfTheTypepOfHarmfulOrganism,
    HarmfulOrganismsAttributesOfASubsetOfTheTypeOfHarmfulOrganism,
    PhasesOfPlantGrowthAndDevelopmentTheMainPhases,
    PhasesOfPlantGrowthAndDevelopmentSubphases,
}
